module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"productSearchTitle":"Select products to add","getProductError":"Error getting product information","typeToSearch":"Type to search","emptyFieldError":"Mandatory field"},"es":{"productSearchTitle":"Selecciona productos para agregar","getProductError":"Error obteniendo información del producto","typeToSearch":"Escribe para buscar","emptyFieldError":"Campo obligatorio"}}')
  delete Component.options._Ctor
}
